import React, { useState } from "react";
import { Modal, Table, ProgressBar, Button, Row, Col, Card} from "react-bootstrap";

const MonthlyCalendar = ({ year, month, tasks }) => {


  const daysInMonth = new Date(year, month, 0).getDate(); // Number of days in the month
  const firstDay = new Date(year, month - 1, 1).getDay(); // First day of the month (0 = Sunday)

 
  // State for the selected date
  const [selectedDate, setSelectedDate] = useState(null);
  const [showModal, setShowModal] = useState(false);


  // Initialize an empty array for the calendar
  const calendarDays = Array(firstDay).fill(null); // Padding for the first week
  for (let i = 1; i <= daysInMonth; i++) {
    const formattedDate = `${year}-${String(month).padStart(2, "0")}-${String(i).padStart(2, "0")}`;
    const task = tasks.find((t) => t._id?.endDate === formattedDate);
    // const task = tasks.find((t) => t._id.endDate === `${year}-${String(month).padStart(2, "0")}-${String(i).padStart(2, "0")}`);
    calendarDays.push({
      date: i,
      statuses: task?.statuses || [],
      tasks: task?.tasks || [],
    });
  }

  // Add padding at the end to complete the last week
  while (calendarDays.length % 7 !== 0) {
    calendarDays.push(null);
  }

  // Create rows for each week
  const weeks = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    weeks.push(calendarDays.slice(i, i + 7));
  }

  console.log("weeks", weeks);

  const handleDayClick = (day) => {
    if(day && day.tasks.length > 0){
      setSelectedDate(day);
      setShowModal(true);
    }
  };

  const getDayStyle = (day) => {
    if (!day) {
      return {
        backgroundColor: "transparent",
        color: "black",
        cursor: "default",
      };
    }

    if (day.tasks.length === 0) {
      return {
        backgroundColor: "white",
        color: "black",
        cursor: "default",
      };
    }

    const statuses = day.statuses;
    if (statuses.includes("pending")) {
      return {
        backgroundColor: "red",
        color: "white",
        cursor: "pointer",
      };
    }

    if (statuses.includes("completed")) {
      return {
        backgroundColor: "green",
        color: "white",
        cursor: "pointer",
      };
    }

    return {
      backgroundColor: "white",
      color: "black",
      cursor: "default",
    };
  };


   // Calculate completed compliance
   const completedDays = calendarDays.filter((day) => {
    return (
      day &&
      day.tasks.length > 0 &&
      !day.statuses.includes('pending')
    );
  }).length;

  const compliancePercentage = Math.floor((completedDays / daysInMonth) * 100);
  
  return (
    <div className="Calender">

    <Table bordered responsive>
      <thead>
        <tr>
          <th>Sun</th>
          <th>Mon</th>
          <th>Tue</th>
          <th>Wed</th>
          <th>Thu</th>
          <th>Fri</th>
          <th>Sat</th>
        </tr>
      </thead>
      <tbody>
        {weeks.map((week, index) => (
          <tr key={index}>
            {week.map((day, idx) => (
              <td
                key={idx}
                onClick={() => day && handleDayClick(day)}
                style={{
                  ...getDayStyle(day),
                  textAlign: "center",
                }}
              >
                {day ? day.date : ""}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </Table>



      {/* Progress Bars */}
      <div className="mt-3">
        <Row className="justify-content-center">
          <Col md={12}>
            <p>Overall Compliance: {completedDays}/{daysInMonth} Days </p>
            <ProgressBar
              animated
              now={compliancePercentage}
              label={`${compliancePercentage}%`}
              variant="primary"
            />
          </Col>
        </Row>
      </div>


 {/* Modal for Task Details */}
    <Modal size="lg" show={showModal} onHide={() => setShowModal(false)} >
        <Modal.Header closeButton>
          <Modal.Title>Task Details for {selectedDate?.date}/{month}/{year}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-4 pb-2">
          {selectedDate?.tasks?.length > 0 ? (
            <>
              {selectedDate.tasks.map((task, idx) => (
                <Card key={idx} id="TaskList"  className={ `${task.status === "pending" ? "border border-danger" : "border border-success"} mb-4` }>
                  <Card.Header className="d-flex justify-content-between align-items-center gap-3">
                    <p className="mb-0">{task.taskName} </p>
                    <p className={`${task.status} mb-0`}>{task.status}</p></Card.Header>
                  <Card.Body>
                    <div className="mb-2">
                      <p className="label">Description</p>
                      <p className="value">{task.taskDescription}</p>
                    </div>

                    <Row>
                      <Col md={3}>
                        <p className="label">Project</p> 
                        <p className="value">{task.projectName}</p>
                      </Col>

                      <Col md={3}>
                        <p className="label">Category</p> 
                        <p className="value">{task.categoryOfName}</p>
                      </Col>

                      <Col md={2}>
                        <p className="label">Estimate Hr</p> 
                        <p className="value">{task.initialEstimateHr + " Hr"}</p>
                      </Col>

                      <Col md={2}>
                        <p className="label">Actual Hr</p> 
                        <p className="value">{task.actualHours + " Hr"}</p>
                      </Col>

                      <Col md={2}>
                        <p className="label">Priority</p> 
                        <p className="value">{task.taskPriority}</p>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              ))}
            </>
          ) : (
            <p>No tasks for this date.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default MonthlyCalendar;




